/* eslint-disable no-empty */
import { call, put, takeLatest } from 'redux-saga/effects';

import { BORROWERS,BORROWERSUPDATE,getPAN,sendOTPAPI,authUserAPI,availCredit,getDocumentAPI,uploadDocumentAPI,setOfferAPI,callEsignInit,getBorrowerAPI,getActListAPI,getIFSCRAzorPay,checkEsignAPI,getIFSCAcct,createBankAcccountAPI,getBankListAPI,initEmandateAPI,phyEmandateAPI,setApiStepApi,getEsignDocumentAPI,getPhoneList,esignEmailAPI,getPIN } from '../services';
import { setPAN,saveOTPAction,saveErrorEsignData,saveAuthToken,saveAuthTokenBorrower,saveSelectOffer,saveDocument,saveBROW,saveCreditAvail,getDocument,setToastM,stopLoader,saveUpdateBROW,saveEsignData,startLoader,setREPEAT,setREPEATNew,saveBankApiDetail,saveEsignList,getPennyBankApiData,saveBankAccount,saveBankAcctList,saveInitEmandate,savePhyEmandate,saveEmandateList,saveEmailEsign,addLoadDocument,removeLoadDocument,setPIN } from './actions';
import { deserialize } from 'jsonapi-fractal'
import { Mixpanel,trackStrings } from '../services/mixpanel';
import { CHECK_ESIGN,IFSC_API,CREATE_BRO,GET_PAN,SEND_OTP,AUTH_USER,KNOW_YOUR_CREDIT,SET_OFFER,GET_DOCUMENT_LIST,UPLOAD_DOCUMENT,UPDATE_BRO,ESIGN_INIT,PENNY_DROP_CALL,CREATE_BANK_ACC,GET_BANK_LIST,INIT_EMANDATE,PHY_NACH,SET_API_STEP,GET_ESIGN_DOCUMENT_LIST,GET_EMAIL_ESIGN,GET_PIN } from './constants';
import { store } from '../../configureStore';

const getAPIKEY = () => {
  return store.getState().app.apiKey;
}

function getErrMessage(errs1) {
  let data = "";
  if(errs1.error) {
    data = errs1.error;
  }
  else {
    var errs = errs1.errors;
    for(var x in errs) {
      var pointerSplit = errs[x].source.pointer.split('/');
      var removeUnderScore = pointerSplit[pointerSplit.length-1].replace(/_/g, ' ');
      var cnnt = removeUnderScore +" "+ errs[x].detail;

      var newMsg = cnnt[0].toUpperCase() + cnnt.slice(1)

      data += data === "" ? newMsg : ", "+newMsg; 
    }
  }
  return data;
}

function getErrCODE(errs) {
  let data = [];
  for(var x in errs) {
    data.push(errs[x].code) 
  }
  return data;
}

function* borrowers(props) {
  try {
    const response = yield call(BORROWERS,props.payload.data);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.REGISTER_SCREEN_CREATE_BORROWER_SUCCESS, {
            anchor_key: getAPIKEY(),
            request_data: props.payload.data,
            borrower: data
      });
      yield put(saveBROW(data));
    }

  } catch(err) {
    if(err && err.data){ 
      Mixpanel.track(trackStrings.REGISTER_SCREEN_CREATE_BORROWER_ERROR, {
            anchor_key: getAPIKEY(),
            request_data: props.payload.data,
            error: err
      });
      if(err.data.errors && getErrCODE(err.data.errors).indexOf("ER-GEN-108") !== -1) {
        yield put(setREPEAT())
      }
      else {
        yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
      }      
    }
    yield put(stopLoader('loaderRegister'))
  }
}

function* updateborrowers(props) {
  try {
    const response = yield call(BORROWERSUPDATE,props.payload.data,props.payload.borrowerResponse);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.DIRECTOR_SCREEN_UPDATE_BORROWER_SUCCESS, {
            anchor_key: getAPIKEY(),
            borrower: data
      });
      yield put(saveUpdateBROW(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.DIRECTOR_SCREEN_UPDATE_BORROWER_ERROR, {
            anchor_key: getAPIKEY(),
            error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderDirector'))
  }
}

function* getPan(props) {
    if(props.payload.flag) {

      try {

        const responsePhone = yield call(getPhoneList,props.payload.pan);
        
        if(responsePhone && responsePhone.data) {
          var dataPhone = deserialize(responsePhone);
          yield put(setREPEATNew(dataPhone.mobile_number))
          yield put(stopLoader('panLoading'))
        }
      }
      catch(err1) {
        
        try {
          const response = yield call(getPAN,props.payload.pan);

          if(response && response.data) {
            var data = deserialize(response);
             yield put(setPAN(props.payload.pan,data));
          }

        } catch(err2) {
          
          /*if(err2 && err2.data){
            yield put(setToastM({status: "error",message: getErrMessage(err2.data)}))
          }*/
          yield put(stopLoader('panLoading'))
        }

      }

    }
    else {
     
      
       try {
        
          const response = yield call(getPAN,props.payload.pan);

          if(response && response.data) {
            var data = deserialize(response);
             yield put(setPAN(props.payload.pan,data));
          }

        } catch(err) {
          
          /*if(err && err.data){
            yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
          }*/
          yield put(stopLoader('panLoading'))
        }

    }
 
}

function* getPin(props) {
  try {
    const response = yield call(getPIN,props.payload.pin);

    if(response && response.data) {
      var data = deserialize(response);
      yield put(setPIN(props.payload.pin,data));
    }

  } catch(err) {
    yield put(setPIN(props.payload.pin,{isError: true}));
    /*if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }*/
    yield put(stopLoader('pinLoading'))
  }
}


function* sendOtpSaga(props) {
  try {
    const response = yield call(sendOTPAPI,props.payload.data);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.REGISTER_SCREEN_OTP_SUCCESS, {
            anchor_key: getAPIKEY(),
            otp: data
      });
      yield put(saveOTPAction(data));
      let messageOTP = `OTP sent on XXXXXX${data.recipient.substr(6,4)} successfully.`;
      if(props.payload.data && props.payload.data.repeatUser && props.payload.data.repeatUser === true) {
        messageOTP = `You have been already registered with us. ${messageOTP}`
      }
      yield put(setToastM({status: "success",message: messageOTP}));

    }

  } catch(err) {
    Mixpanel.track(trackStrings.REGISTER_SCREEN_OTP_ERROR, {
            anchor_key: getAPIKEY(),
            error: err
    });
    yield put(setToastM({status: "error",message: "Unable to send OTP."}));
    yield put(stopLoader('loaderOTP'))
  }
}

function* AuthUser(props) {
  try {
    const response = yield call(authUserAPI,props.payload.otp,props.payload.otpResponse,props.payload.borrowerResponse);

    if(response && response.data) {
      Mixpanel.reset();
      Mixpanel.identify(props.payload.otpResponse.recipient);

      var data = deserialize(response);
      
      if(props.payload.borrowerResponse && props.payload.borrowerResponse.repeatUser === true){
        let { token } = data;
        const responseBro = yield call(getBorrowerAPI,token);

        var dataOld = deserialize(responseBro);

        try {
          const responseAct = yield call(getActListAPI,token);

          var responseACTval = deserialize(responseAct);

          Mixpanel.track(trackStrings.REGISTER_SCREEN_AUTH_LIST_SUCCESS, {
                anchor_key: getAPIKEY(),
                act_list: responseACTval,
                borrower: dataOld
          });

          yield put(saveAuthTokenBorrower(data,dataOld,responseACTval));
        }
        catch(err1) {
          Mixpanel.track(trackStrings.REGISTER_SCREEN_AUTH_LIST_ERROR, {
                anchor_key: getAPIKEY(),
                error: err1
          });

          if(err1.data.errors && (getErrCODE(err1.data.errors).indexOf("ER-CRDT-101") !== -1 || getErrCODE(err1.data.errors).indexOf("ER-ACI-101") !== -1 || getErrCODE(err1.data.errors).indexOf("ER-GEN-115") !== -1)) {
            yield put(saveAuthTokenBorrower(data,dataOld,null));
          }
          else if(err1 && err1.data){
            yield put(setToastM({status: "error",message: getErrMessage(err1.data)}))
          }
          yield put(stopLoader('loaderOTP'))

        }
      }
      else {
        yield put(saveAuthToken(data));
        yield put(stopLoader('loaderOTP'))
      }
      
    }

  } catch(err) {
    Mixpanel.track(trackStrings.REGISTER_SCREEN_AUTH_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderOTP'))
  }
}

function* setApiStep(props) {
  try {
    const response = yield call(setApiStepApi,props.payload.key);

    if(response && response.data) { 
      var responseData = deserialize(response);
      Mixpanel.track(trackStrings.EMANDATE_SCREEN_SET_STEP_SUCCESS, {
          anchor_key: getAPIKEY(),
          data: responseData
      });     
      yield put(saveEmandateList());   
    }

  } catch(err) {
    Mixpanel.track(trackStrings.EMANDATE_SCREEN_SET_STEP_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
  }
}

function* KnowYourOffer1(props) {
  
  try {
    
    const response = yield call(availCredit,props.payload.customer_code);

    if(response && response.data) {
      var data = deserialize(response);

      if(data.offers && data.offers.length > 0) {
        Mixpanel.track(trackStrings.OFFER_SCREEN_OFFER_SUCCESS, {
            anchor_key: getAPIKEY(),
            offer: data
        });
      }
      else {
        Mixpanel.track(trackStrings.OFFER_SCREEN_OFFER_EMPTY, {
            anchor_key: getAPIKEY(),
            offer: data
        });
      }
      
      yield put(saveCreditAvail(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.OFFER_SCREEN_OFFER_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderOffer'))
  }
}

function* setOffer(props) {
  
  try {
    
    const response = yield call(setOfferAPI,props.payload.data);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.OFFER_SCREEN_OFFER_SET_SUCCESS, {
          anchor_key: getAPIKEY(),
          offer_set: data
      });
      yield put(saveSelectOffer(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.OFFER_SCREEN_OFFER_SET_ERROR, {
          anchor_key: getAPIKEY(),
          offer_set: data
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderOffer'))
  }
}



function* getDocumentLIst(props) {
  
  try {
    yield put(startLoader('loaderDocument'))
    const response = yield call(getDocumentAPI);
    
    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.DOCUMENT_SCREEN_LIST_SUCCESS, {
          anchor_key: getAPIKEY(),
          document: data
      });
      yield put(saveDocument(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.DOCUMENT_SCREEN_LIST_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderDocument'))
  }
}

function* getEsignDocumentList(props) {
  
  try {
    yield put(startLoader('loaderEsignDocument'))
    const response = yield call(getEsignDocumentAPI);
    
    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.ESIGN_SCREEN_DOCUMENT_LIST_SUCCESS, {
          anchor_key: getAPIKEY(),
          document: data
      });
      yield put(saveDocument(data));
      yield put(stopLoader('loaderEsignDocument'))
    }

  } catch(err) {
    Mixpanel.track(trackStrings.ESIGN_SCREEN_DOCUMENT_LIST_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderEsignDocument'))
  }
}


function* uploadDocument(props) {
  try {

    yield put(addLoadDocument(props.payload.documentId));
    
    const response = yield call(uploadDocumentAPI,props.payload.file,props.payload.documentId);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.DOCUMENT_SCREEN_UPLOAD_SUCCESS, {
          anchor_key: getAPIKEY(),
          document: data
      });
      yield put(getDocument());
      yield put(removeLoadDocument(props.payload.documentId));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.DOCUMENT_SCREEN_UPLOAD_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    yield put(removeLoadDocument(props.payload.documentId));
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
  }
}

function* initEsign(props) {
  try {
    const response = yield call(callEsignInit,props.payload.co_borrower_id);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.ESIGN_SCREEN_INIT_SUCCESS, {
          anchor_key: getAPIKEY(),
          esign: data
      });
      yield put(saveEsignData(data));
    }

  } catch(err) {
      Mixpanel.track(trackStrings.ESIGN_SCREEN_INIT_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
      });
     if(err && err.data){
        yield put(saveErrorEsignData(err.data));
        yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
      }
      yield put(stopLoader('loaderEsign'))
  }
}

function* getIFSCDetail(props) {
  try {
    const response = yield call(getIFSCRAzorPay,props.payload.ifsc);

    if(response) {
      Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_IFSC_SUCCESS, {
          anchor_key: getAPIKEY(),
          bank: response
      });
      yield put(saveBankApiDetail(response));
    }

  } catch(err) {
      Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_IFSC_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
      });
     /*if(err && err.data){
        yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
      }*/
      yield put(stopLoader('loaderIFSC'))      
  }
}

function* getIFSCAccDetail(props) {
  try {
    const response = yield call(getIFSCAcct,props.payload.ifscCode,props.payload.accountNumber);

    if(response) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_ACC_SUCCESS, {
          anchor_key: getAPIKEY(),
          bank: data
      });
      yield put(getPennyBankApiData(data));
    }

  } catch(err) {
      Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_ACC_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
      });
      /*if(err && err.data){
        yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
      }*/
      yield put(stopLoader('loaderPennyDrop'))
  }
}

function* checkEsignSaga(props) {
  try {
    const response = yield call(checkEsignAPI);

    if(response && response.data) {
      var data = deserialize(response);
      yield put(saveEsignList(data,props.payload.interVal));
    }

  } catch(err) {
     if(err && err.data){
        yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
      }
  }
}

function* createBankAcccount(props) {
  try {
    const response = yield call(createBankAcccountAPI,props.payload.data);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_ACC_ADD_SUCCESS, {
          anchor_key: getAPIKEY(),
          bank: data
      });
      yield put(saveBankAccount(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.BANK_ACCOUNT_SCREEN_ACC_ADD_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderBank'))
  }
}

function* getBankList(props) {
  try {
    const response = yield call(getBankListAPI);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.EMANDATE_SCREEN_LIST_SUCCESS, {
            anchor_key: getAPIKEY(),
            bank: data
      });
      yield put(saveBankAcctList(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.EMANDATE_SCREEN_LIST_ERROR, {
            anchor_key: getAPIKEY(),
            error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderBank'))
  }
}

function* initEmandate(props) {
  try {
    const response = yield call(initEmandateAPI);

    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.EMANDATE_SCREEN_INIT_SUCCESS, {
            anchor_key: getAPIKEY(),
            emandate: data
      });
      yield put(saveInitEmandate(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.EMANDATE_SCREEN_INIT_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderEmandate'))
  }
}


function* phyEmandate(props) {
  
  try {
    const response = yield call(phyEmandateAPI);
    if(response && response.data) {
      var data = deserialize(response);
      Mixpanel.track(trackStrings.EMANDATE_SCREEN_PHY_SUCCESS, {
            anchor_key: getAPIKEY(),
            emandate: data
      });
      yield put(savePhyEmandate(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.EMANDATE_SCREEN_PHY_ERROR, {
          anchor_key: getAPIKEY(),
          error: err
    });
    if(err && err.data){
      yield put(setToastM({status: "error",message: getErrMessage(err.data)}))
    }
    yield put(stopLoader('loaderEmandate'))
  }
}


function* getEmailEsignSaga(props) {

 Mixpanel.track(trackStrings.ESIGN_SCREEN_EMAIL_DATA_REQUEST, {
        esign_payload: props.payload.esign_id
 });
 
 yield put(startLoader('loaderEsignDocument'))
  try {
    yield put(startLoader('loaderEsignDocument'))
    const response = yield call(esignEmailAPI,props.payload.esign_id);
    if(response && response.data) {
      var data = deserialize(response);
     
      Mixpanel.track(trackStrings.ESIGN_SCREEN_EMAIL_DATA_SUCCESS, {
            esign_data: data,
            esign_payload: props.payload.esign_id
      });

      yield put(saveEmailEsign(data));
    }

  } catch(err) {
    Mixpanel.track(trackStrings.ESIGN_SCREEN_EMAIL_DATA_ERROR, {
        error: err,
        esign_payload: props.payload.esign_id
    });
    if(err && err.data){      
      yield put(saveEmailEsign({min_error: getErrMessage(err.data)}));
    }
    yield put(stopLoader('loaderEsignDocument'))
  }
} 

export default function* appSaga() {
  yield takeLatest(CREATE_BRO, borrowers);
  yield takeLatest(GET_PAN, getPan);
  yield takeLatest(SEND_OTP, sendOtpSaga);
  yield takeLatest(AUTH_USER, AuthUser);
  yield takeLatest(KNOW_YOUR_CREDIT,KnowYourOffer1);
  yield takeLatest(SET_OFFER, setOffer);
  yield takeLatest(GET_DOCUMENT_LIST, getDocumentLIst);
  yield takeLatest(UPLOAD_DOCUMENT, uploadDocument);
  yield takeLatest(UPDATE_BRO, updateborrowers);
  yield takeLatest(ESIGN_INIT, initEsign);
  yield takeLatest(IFSC_API, getIFSCDetail);
  yield takeLatest(PENNY_DROP_CALL, getIFSCAccDetail);
  yield takeLatest(CREATE_BANK_ACC, createBankAcccount);
  yield takeLatest(CHECK_ESIGN, checkEsignSaga);
  yield takeLatest(GET_BANK_LIST, getBankList);
  yield takeLatest(INIT_EMANDATE, initEmandate);
  yield takeLatest(PHY_NACH, phyEmandate);
  yield takeLatest(SET_API_STEP, setApiStep);
  yield takeLatest(GET_ESIGN_DOCUMENT_LIST, getEsignDocumentList);
  yield takeLatest(GET_EMAIL_ESIGN, getEmailEsignSaga);  
  yield takeLatest(GET_PIN, getPin);
}
